module.exports = __webpack_public_path__ + "assets/imgs/logos/adjust.5744908fa945af8c6516adbda941a948.png";